import React from 'react';
import General from './General/';
import ListStyleOne from '../../components/list-style/one';
import HomeContentSection from '../Home/HomeContentSection/';

const Software = (props) => {
  return (
    <>
      <General lang={props.lang} items={props.functionalities.edges}/>
      <section>
        <ListStyleOne itemsAreVideos lang={props.lang} align='left' items={props.functionalitiesGroup.edges[0]} />
        <ListStyleOne itemsAreVideos lang={props.lang} align='right' items={props.functionalitiesGroup.edges[1]} />
        <ListStyleOne itemsAreVideos lang={props.lang} align='left' items={props.functionalitiesGroup.edges[2]} />
      </section>
      <HomeContentSection lang={props.lang}/>
    </>
  );
}
  
export default Software;